<template>
    <button :aria-label="textLabel" v-bind="$attrs">
        <template v-html="icons[type]" v-if="!custom"></template>
        <span class="more more--arrow" v-else>
            <span 
                class="more__icon" 
                v-html="icons[type]" 
            />
            <span 
                class="more__text" 
                v-text="textLabel" 
            />
        </span>
    </button>
</template>

<script>
const buttonIcons = {
    play: `
        <svg role="img" aria-label="Play icon" xmlns="http://www.w3.org/2000/svg" width="512px" height="512px" viewBox="0 0 373.008 373.008">
            <path d="M61.792,2.588C64.771,0.864,68.105,0,71.444,0c3.33,0,6.663,0.864,9.655,2.588l230.116,167.2    c5.963,3.445,9.656,9.823,9.656,16.719c0,6.895-3.683,13.272-9.656,16.713L81.099,370.427c-5.972,3.441-13.334,3.441-19.302,0    c-5.973-3.453-9.66-9.833-9.66-16.724V19.305C52.137,12.413,55.818,6.036,61.792,2.588z" fill="#fff"/>
        </svg>
    `,
    pause: `
        <svg role="img" aria-label="Pause icon" v-if="!custom" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70" width="512px" height="512px">
            <path d="M52.5,0c-4.972,0-9,1.529-9,6.5v57c0,4.971,4.028,6.5,9,6.5c4.971,0,9-1.529,9-6.5v-57     C61.5,1.529,57.471,0,52.5,0z" fill="#FFFFFF"/>
            <path d="M17.5,0c-4.972,0-9,1.529-9,6.5v57c0,4.971,4.028,6.5,9,6.5c4.971,0,9-1.529,9-6.5v-57     C26.5,1.529,22.471,0,17.5,0z" fill="#FFFFFF"/>
        </svg>
    `,
}

export default {
    props: {
        textLabel: {
            type: String,
            default: 'Play video'
        },
        type: {
            type: String,
            default: 'play'
        },
        custom: Boolean,
    },
    computed: {
        icons() {
            return buttonIcons
        },
    },
}
</script>